import { render, staticRenderFns } from "./RelationshipList.vue?vue&type=template&id=a89bd220&"
import script from "./RelationshipList.vue?vue&type=script&lang=js&"
export * from "./RelationshipList.vue?vue&type=script&lang=js&"
import style0 from "./RelationshipList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports